import React from 'react';
import './App.css';
import ContainerAddDate from './components/containerAddDate/containerAddDate';
import ContainerSubmitDate from './components/containerSubmitDate/containerSubmitDate';
import EmailForm from './components/emailForm/emailForm';

function App() {
    return (
        <div className="App">
            <p>Under construction</p>
            <div className="containerApp">
                <ContainerAddDate />
                <ContainerSubmitDate />
                <EmailForm />
            </div>
        </div>
  );
}

export default App;
